module.exports = __webpack_public_path__ + "static/media/buildingnew.89576f8f.svg";